import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';
import { VictoryIcon } from '@change/ds-icons';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePetitionDetailsPageData } from 'src/app/pages/petitionDetails/pageContext';

export function PetitionStatusHeaderContainer(): JSX.Element {
	const {
		data: {
			petition: { isVerifiedVictory },
		},
	} = usePetitionDetailsPageData();
	return (
		<div className="block md:hidden">
			<div className="rounded-medium bg-gradient-background-dark-1 p-2">
				<div className="flex flex-row justify-center gap-1 text-typography-inverse-strong">
					<VictoryIcon />
					<Text as="h3" variant="heading" size="small">
						{isVerifiedVictory ? (
							<Translate value="fe.pages.petition_show.status.confirmed_victory" />
						) : (
							<Translate value="fe.pages.petition_show.status.victory" />
						)}
					</Text>
				</div>
			</div>
		</div>
	);
}
